import { useNavigation } from "@react-navigation/native";
import React, { ReactElement } from "react";
import { widthPercentageToDP } from "react-native-responsive-screen";
import { Box } from "./Box/MainBox/MainBox";
import { MainTitle } from "./MainTitle";
import { PressableOpacity } from "./PressableOpacity";
import theme, { Theme } from "app/Theme/Theme";
import { ResponsiveValue } from "@shopify/restyle";

export interface IHeaderFullScreenProps {
  title: string;
  leftIcon?: ReactElement;
  rightIcon?: ReactElement;
  callbackOnPressLeft?: () => void;
  callbackOnPressRight?: () => void;
  marginBottom?: ResponsiveValue<keyof Theme["spacing"], Theme>;
}

const HeaderFullScreen = ({
  title,
  leftIcon,
  rightIcon,
  callbackOnPressLeft,
  callbackOnPressRight,
  marginBottom = "xs",
  marginTop = "null",
}: IHeaderFullScreenProps) => {
  const navigation = useNavigation();

  const pressedLeftIcon = () => {
    if (!callbackOnPressLeft) {
      navigation.goBack();
    } else {
      callbackOnPressLeft();
    }
  };
  const pressedrightIcon = () => {
    if (!callbackOnPressRight) {
      navigation.goBack();
    } else {
      callbackOnPressRight();
    }
  };

  return (
    <Box
      alignSelf="center"
      width={widthPercentageToDP("90%")}
      flexDirection="row"
      alignItems="center"
      marginTop={marginTop}
      marginBottom={marginBottom}
    >
      {leftIcon && (
        <Box alignItems="center" marginRight="s">
          <PressableOpacity onPress={pressedLeftIcon}>
            {leftIcon}
          </PressableOpacity>
        </Box>
      )}
      <Box flex={1} alignItems="flex-start">
        <MainTitle variant="l8-bold">{title}</MainTitle>
      </Box>
      <Box alignItems="center" marginLeft="s">
        {rightIcon && (
          <PressableOpacity hitSlop={theme.hitSlop} onPress={pressedrightIcon}>
            {rightIcon}
          </PressableOpacity>
        )}
      </Box>
    </Box>
  );
};

export default HeaderFullScreen;
